"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _inputGroup = _interopRequireDefault(require("../../input-group"));

var _select = _interopRequireDefault(require("../../select"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var TimePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(TimePicker, _PureComponent);

  var _super = _createSuper(TimePicker);

  function TimePicker() {
    var _this;

    _classCallCheck(this, TimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getCurrentHours", function (date) {
      return date ? date.getHours() : 12;
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentMinutes", function (date) {
      return date ? date.getMinutes() : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getFormattedHour", function (hour) {
      if (_this.props.ampmTimeFormat) {
        if (hour === 0) {
          return '12 AM';
        }

        if (hour === 12) {
          return '12 PM';
        }

        return hour > 12 ? "".concat(hour - 12, " PM") : "".concat(hour, " AM");
      }

      return hour.toLocaleString('en-US', {
        minimumIntegerDigits: 2
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hours", new Array(24).fill().map(function (v, index) {
      return {
        label: _this.getFormattedHour(index),
        value: index
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "minutes", new Array(60).fill().map(function (v, index) {
      return {
        label: index.toLocaleString('en-US', {
          minimumIntegerDigits: 2
        }),
        value: index
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (type, value) {
      var currentDate = _this.props.value || new Date();

      _this.props.onChange(new Date(currentDate.setMilliseconds(1)));

      if (type === 'hours') {
        setTimeout(function () {
          _this.props.onChange(new Date(currentDate.setHours(value)));
        });
      } else {
        setTimeout(function () {
          _this.props.onChange(new Date(currentDate.setMinutes(value)));
        });
      }
    });

    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var ampmTimeFormat = this.props.ampmTimeFormat;
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-datepicker-timepicker')
      }, void 0, /*#__PURE__*/_jsx(_inputGroup["default"], {
        appearance: "two-dots"
      }, void 0, /*#__PURE__*/_jsx(_select["default"], {
        input: {
          name: 'time',
          value: this.getCurrentHours(this.props.value),
          onChange: this.handleChange.bind(this, 'hours')
        },
        options: this.hours,
        size: "sm",
        disabled: this.props.disabled,
        disabledLimitationMinWidth: true,
        style: {
          width: ampmTimeFormat ? 95 : 80
        }
      }), /*#__PURE__*/_jsx(_select["default"], {
        input: {
          name: 'time',
          value: this.getCurrentMinutes(this.props.value),
          onChange: this.handleChange.bind(this, 'minutes')
        },
        options: this.minutes,
        size: "sm",
        disabled: this.props.disabled || this.props.disabledMinutes,
        disabledLimitationMinWidth: true,
        style: {
          width: 80
        }
      })));
    }
  }]);

  return TimePicker;
}(_react.PureComponent);

var _default = TimePicker;
exports["default"] = _default;